import type { ScenarioNode } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const scenarioNodeSchema = z.object({
  id: z.string(),
  type: z.string(),
  label: z.string(),
  invalid_tip: z.string().optional(),
  properties: z.object({}).catchall(z.any()),
  meta_properties: z.object({}).catchall(
    z.object({
      visible: z.boolean().optional(),
      mode: z.enum(['expression', 'fixed']).optional(),
    }),
  ),
  retry_on_fail: z.boolean().default(false),
  max_retries: z.number().min(1).max(5).default(3),
  retry_interval: z.number().min(100).max(5000).default(1000),
  on_error: z.enum(['stop', 'continue', 'fail_branch']).default('stop'),
  position: z.object({
    x: z.number(),
    y: z.number(),
  }),
  targets: z.object({}).catchall(z.string()),
}) as unknown as ToZod<ScenarioNode>

export type ScenarioNodeSchema = ScenarioNode